import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import * as moment from "moment";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";

import { MenuUsers } from "../../Model/menu-users";
import { MenuUsersService } from "../../Services/menu-users.service";

@Component({
  selector: "menu-security-form",
  templateUrl: "./menu-security-form.component.html",
  styleUrls: ["./menu-security-form.component.css"],
})
export class MenuSecurityFormComponent implements OnInit, OnChanges {
  @Input()
  changeTrigger: number;

  @Input()
  mode: string;

  @Input()
  menuSecurityRow;

  @Output()
  close: EventEmitter<any> = new EventEmitter();

  public form: FormGroup;
  public dialogTitle: string;

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private menuUsersService: MenuUsersService
  ) {
    this.createFormGroup();
  }

  createFormGroup() {
    this.form = this.fb.group({
      user: new FormControl([], Validators.required),
      menu: new FormControl([], Validators.required),
    });
  }

  ngOnChanges() {
    if (this.mode == "Update") {
      this.dialogTitle = "Edit Security";

      this.form.patchValue({
        user: this.menuSecurityRow.user,
        menu: this.menuSecurityRow.menuName,
      });
    } else {
      this.form.reset();
    }
  }

  ngOnInit() {}

  onDeleteClicked() {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        // Delete single menu item
        if (this.menuSecurityRow.menuName) {
          this.menuUsersService
            .deleteById(this.menuSecurityRow.id)
            .subscribe((response: any) => {
              if (response["success"] != "true") {
                this.toastr.error("Error occurred deleting user/menu");
              } else {
                this.toastr.success("User/Menu deleted successfully");
                this.close.emit({});
              }
            });
        } else {
          // Delete all for user
          this.menuUsersService
            .deleteByUser(this.menuSecurityRow.user)
            .subscribe((response: any) => {
              if (response["success"] != "true") {
                this.toastr.error("Error occurred deleting user/menu");
              } else {
                this.toastr.success("User/Menu deleted successfully");
                this.close.emit({});
              }
            });
        }
      }
    });
  }

  onSaveClick() {
    if (this.mode == "Update") {
      let formData = {
        authName: this.form.get("menu").value,
        user: this.form.get("user").value,
        id: this.menuSecurityRow.id,
      };
      this.menuUsersService.update(formData).subscribe((response: any) => {
        if (response["success"] != "true") {
          this.toastr.error("Error occurred while updating user/menu");
        } else {
          this.toastr.success("User/Menu updated successfully");
          this.close.emit({});
        }
      });
    } else {
      let formData = {
        authName: this.form.get("menu").value,
        user: this.form.get("user").value,
      };
      this.menuUsersService.create(formData).subscribe((response: any) => {
        if (response["success"] != "true") {
          this.toastr.error("Error occurred while creaing user/menu");
        } else {
          this.toastr.success("User/Menu created successfully");
          this.close.emit({});
        }
      });
    }
  }

  onSaveContinueClick() {
    let formData = {
      authName: this.form.get("menu").value,
      user: this.form.get("user").value,
    };
    this.menuUsersService.create(formData).subscribe((response: any) => {
      if (response["success"] != "true") {
        this.toastr.error("Error occurred while creaing user/menu");
      } else {
        this.toastr.success("User/Menu created successfully");
        this.form.reset();
      }
    });
  }

  closeDialog() {
    this.form.reset();
    this.close.emit({});
  }
}
